import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "starFilled"
const StarFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.327 2.862C11.516 2.48 11.952 2.36 12.294 2.503 12.45 2.568 12.587 2.688 12.673 2.863L15.306 8.198 21.196 9.055C21.81 9.145 22.056 9.9 21.61 10.334L17.35 14.488 18.355 20.354Q18.378 20.493 18.352 20.619 18.35 20.645 18.342 20.67 18.336 20.692 18.33 20.713 18.32 20.738 18.312 20.762 18.301 20.789 18.287 20.815L18.27 20.848Q18.255 20.875 18.236 20.9L18.216 20.93 18.178 20.975 18.153 21.002 18.11 21.042Q18.096 21.057 18.079 21.068L18.037 21.1 17.999 21.123Q17.976 21.138 17.952 21.15L17.912 21.168 17.867 21.187 17.817 21.202Q17.796 21.21 17.77 21.215L17.71 21.225 17.679 21.228Q17.646 21.23 17.615 21.23H17.574Q17.556 21.23 17.539 21.226 17.402 21.212 17.267 21.145L12 18.375 6.733 21.145Q6.6 21.212 6.465 21.225 6.445 21.23 6.426 21.23H6.384Q6.353 21.23 6.321 21.229L6.29 21.226 6.23 21.215Q6.203 21.208 6.177 21.2 6.156 21.195 6.134 21.188L6.096 21.172Q6.066 21.159 6.038 21.145L6.013 21.132Q5.983 21.114 5.953 21.092 5.94 21.086 5.93 21.078 5.905 21.057 5.881 21.035 5.864 21.023 5.852 21.01 5.832 20.989 5.813 20.966 5.798 20.95 5.787 20.936L5.753 20.886 5.733 20.857Q5.717 20.827 5.705 20.799L5.689 20.766Q5.678 20.736 5.669 20.707 5.662 20.69 5.657 20.67L5.647 20.62Q5.632 20.545 5.633 20.466V20.46Q5.635 20.408 5.644 20.353L6.65 14.489 2.388 10.334C2.221 10.171 2.152 9.963 2.163 9.762Q2.165 9.712 2.174 9.662 2.193 9.562 2.236 9.472 2.257 9.426 2.286 9.385C2.396 9.215 2.574 9.088 2.804 9.055L8.694 8.199z" />
        </svg>
      }
    </span>
  )
}
export default StarFilledIcon
